import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {ErrorHandlerService} from "../../../error-handler.service";
import {UserData} from "../../auth/user.data";
import {HttpClient} from "@angular/common/http";
import {catchError} from "rxjs";

@Component({
    selector: "fhm-user-select-control",
    templateUrl: "./user-select-control.component.html",
    styleUrls: ["./user-select-control.component.scss"],
    standalone: false
})
export class UserSelectControlComponent implements OnChanges, OnInit {

    @Output() public removed: EventEmitter<any> = new EventEmitter();

    @Output() public valueChange: EventEmitter<string> = new EventEmitter();

    @Input() public value: string;

    @Input() label: string;

    @Input() disabled: boolean;

    @Input() required: boolean;

    public selectedValue: any;

    public options: any[] = [];

    constructor( private http: HttpClient,
                 private auth: AuthApiService,
                 private errorHandler: ErrorHandlerService) {
    }

    ngOnInit(): void {
        this.http.get<UserData[]>("/fonzie/users", {headers: this.auth.getHttpHeaderOptions()})
            .pipe(catchError((error) => {
                return this.errorHandler.handleError(error);
            }))
            .subscribe(data => {
                data.forEach(user => {
                    const record = {label: user.email, value: user.email};
                    this.options.push(record);

                    if (user.email === this.value) {
                        this.selectedValue = record;
                    }
                });
            });
    }

    public updateStateOnValueChange(): void {
        if (this.selectedValue) {
            this.valueChange.emit(this.selectedValue["value"]);
        } else {
            this.valueChange.emit();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.selectedValue = undefined;
        this.options.forEach(d => {
            if (d.value === this.value) {
                this.selectedValue = d;
            }
        });
    }

}
